/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetConnectWifiOffIcon16Light } from './NetConnectWifiOffIcon16Light';
import { NetConnectWifiOffIcon16Regular } from './NetConnectWifiOffIcon16Regular';
import { NetConnectWifiOffIcon16Solid } from './NetConnectWifiOffIcon16Solid';
import { NetConnectWifiOffIcon20Light } from './NetConnectWifiOffIcon20Light';
import { NetConnectWifiOffIcon20Regular } from './NetConnectWifiOffIcon20Regular';
import { NetConnectWifiOffIcon20Solid } from './NetConnectWifiOffIcon20Solid';
import { NetConnectWifiOffIcon24Regular } from './NetConnectWifiOffIcon24Regular';
import { NetConnectWifiOffIcon24Solid } from './NetConnectWifiOffIcon24Solid';
import { NetConnectWifiOffIcon32Regular } from './NetConnectWifiOffIcon32Regular';
import { NetConnectWifiOffIcon64Regular } from './NetConnectWifiOffIcon64Regular';
var sizes = {
    16: {
        light: NetConnectWifiOffIcon16Light,
        regular: NetConnectWifiOffIcon16Regular,
        solid: NetConnectWifiOffIcon16Solid,
    },
    20: {
        light: NetConnectWifiOffIcon20Light,
        regular: NetConnectWifiOffIcon20Regular,
        solid: NetConnectWifiOffIcon20Solid,
    },
    24: {
        regular: NetConnectWifiOffIcon24Regular,
        solid: NetConnectWifiOffIcon24Solid,
    },
    32: {
        regular: NetConnectWifiOffIcon32Regular,
    },
    64: {
        regular: NetConnectWifiOffIcon64Regular,
    },
};
export var NetConnectWifiOffIcon = forwardRef('NetConnectWifiOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
